import { SettingOutlined, TeamOutlined } from '@ant-design/icons';
import { Button, Card, Form, Space, Table, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import AseguradoraEmpresaSelect from '../../modelos/admins/componentes/AseguradoraEmpresaSelect';
import { errorHandler } from '../../utils';
import { instanceRef } from '../../utils/axios';

const AutorizacionAseguradoraEmpresa = () => {
  const {
    params: { id: idAseguradora }
  } = useRouteMatch();
  const [loading, setLoading] = useState();
  const [
    aseguradoraEmpresaProducto,
    setAseguradoraEmpresaProducto
  ] = useState();
  const [aseguradoraempresaId, setAseguradoraEmpresaId] = useState();
  const [aseguradora, setAseguradora] = useState();
  const [url, setUrl] = useState();
  const [form] = Form.useForm();
  const history = useHistory();

  const columns = [
    {
      title: 'Producto',
      dataIndex: ['producto', 'descripcion'],
      key: ['producto', 'descripcion']
    },
    {
      title: 'Acciones',
      key: 'action',
      width: '10px',
      align: 'left',
      render: (text, record) => {
        return (
          <Space size="small">
            <Tooltip title="Verificadores">
              <Button
                icon={<TeamOutlined />}
                type="text"
                size="middle"
                onClick={() => handleOpenVerificadores(record.id)}
              />
            </Tooltip>
            <Tooltip title="Configuración">
              <Button
                disabled={false} // TODO: Se debe habilitar solamente si existe al menos un verificador
                icon={<SettingOutlined />}
                type="text"
                size="middle"
                onClick={() => handleOpenConfig(record.id)}
              />
            </Tooltip>
          </Space>
        );
      }
    }
  ];

  const handleOpenConfig = (id) => {
    const urlConfig = `/autorizacion-configuracion/aseguradoraEmpresaProducto/${id}`;
    history.push(urlConfig);
  };

  const handleOpenVerificadores = (id) => {
    const urlVerificadores = `/verificadores/aseguradoraEmpresaProducto/${id}`;
    history.push(urlVerificadores);
  };
  const getAseguradora = async () => {
    setLoading(true);
    try {
      const response = await instanceRef.instance.get(
        `/aseguradoras/${idAseguradora}`,
        {}
      );
      if (response.data?.data) {
        setAseguradora(response.data.data);
      }

      setLoading(false);
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
  };

  const getAseguradoraEmpresaProducto = async () => {
    setLoading(true);
    try {
      if (url) {
        const response = await instanceRef.instance.get(url);
        if (response.data?.data) {
          setAseguradoraEmpresaProducto(response.data.data.rows);
        }
      }

      setLoading(false);
    } catch (error) {
      errorHandler(error);
    }
    setLoading(false);
  };

  function getAseguradoraEmpresaId(value) {
    setAseguradoraEmpresaId(value.key);
    setUrl(`/aseguradoraempresaproducto/productos/${value.key}`);
  }

  useEffect(() => {
    if (url) {
      getAseguradoraEmpresaProducto();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  useEffect(() => {
    getAseguradora();
    getAseguradoraEmpresaProducto();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ResponsiveContainer size="large">
        <Card
          title={`Configuración de Autorizaciones - ${
            aseguradora?.descripcion || ''
          } `}
          style={{ textAlign: 'left' }}
          loading={!aseguradora}
        >
          <Form form={form} layout="vertical">
            <Form.Item
              label="Empresa:"
              name="empresa"
              rules={[
                {
                  required: true
                }
              ]}
            >
              <AseguradoraEmpresaSelect
                aseguradora={idAseguradora}
                getAseguradoraEmpresaId={getAseguradoraEmpresaId}
              />
            </Form.Item>
          </Form>

          {aseguradoraempresaId && (
            <div style={{ maxWidth: '500px' }}>
              <Table
                fixed
                loading={{
                  spinning: loading,
                  tip: 'Cargando...',
                  delay: 500
                }}
                scroll={false}
                style={{ width: '100%' }}
                bordered
                dataSource={aseguradoraEmpresaProducto}
                columns={columns}
                pagination={false}
                rowKey={(record) => record.id}
                size="small"
              />
            </div>
          )}
        </Card>
      </ResponsiveContainer>
    </>
  );
};

export default AutorizacionAseguradoraEmpresa;
